export default __webpack_public_path__ + "static/media/map_icon.4def8ebc.svg";